import { SaveAttributeFlow, type SaveAttributeBatchResult } from '@/features/workspace-settings'

export class SaveHardalEventsFlow {
  constructor(private readonly attributes = new SaveAttributeFlow()) {}

  async save(
    events: readonly string[],
    primary: string | null,
    ids: { events: number | null; primary: number | null },
  ): Promise<SaveAttributeBatchResult> {
    const normalized = [...new Set(events.map((event) => event.trim()).filter(Boolean))]
    return this.attributes.saveBatch([
      {
        key: 'hardal_events',
        value: normalized.length ? normalized : null,
        attributeId: ids.events,
      },
      {
        key: 'hardal_primary_event',
        value: primary?.trim() || null,
        attributeId: ids.primary,
      },
    ])
  }
}
